import { ISectionType } from '../../../interfaces/scheduler_interfaces';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { TermSectionType } from '../builders/term_course_section_type_builder';
import * as _4 from 'lodash4';

export interface ITermSectionTypesDatasource extends IDatasource<ISectionType> {}

angular
  .module('capability-ng-scheduler')
  .factory(
    'ngTermSectionTypesDatasource',
    (): ITermSectionTypesDatasource =>
      new Datasource({
        builderType: TermSectionType
      })
  )
  .run((ngTermSectionTypesDatasource: ITermSectionTypesDatasource, schedulerConfigModel: any) => {
    // When reg-all_section_type_mandatory feature is enabled all sectionTypes are required.
    ngTermSectionTypesDatasource.$prePut = (sectionType: TermSectionType) => {
      if (_4.isNull(_4.get(sectionType, 'is_required', false))) {
        sectionType.is_required = false;
      }
      if (schedulerConfigModel.isFeatureEnabled('reg-all_section_type_mandatory')) {
        sectionType.is_required = true;
      }
      return sectionType;
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/datasources/term_section_types_datasource.ts